import { useQueryClient } from '@tanstack/react-query'

import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateGameTypeProvider from '@/modules/game/api/hooks/useMutationUpdateGameTypeProvider'
import { GameQueryKeys } from '@/modules/game/keys'

import type { GameProviderWithBannerListTableData } from '@/modules/game/type'

interface IsPopularProviderProps {
	row: GameProviderWithBannerListTableData
}

export function IsPopularProvider({ row }: IsPopularProviderProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateGameTypeProvider } =
		useMutationUpdateGameTypeProvider()

	const handleMutate = async (value: boolean) => {
		await updateGameTypeProvider({
			id: row.id,
			payload: {
				isPopular: value,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [GameQueryKeys.GetGameProviderList],
		})
	}

	return (
		<SetIsActive
			defaultChecked={row.isPopular}
			onMutate={handleMutate}
			successMessage="อัพเดทค่ายยอดนิยมสำเร็จ"
		/>
	)
}
